// extracted by mini-css-extract-plugin
export default {"policy_block":"KYCAMLPolicy_policy_block__j36FU"};